import { useEffect } from 'react'
import { all, dec, equals, isNil, length, not, path, prop } from 'ramda'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useAnalytics } from 'hooks'

const AppFlowHandler = () => {
  const domain = useSelector(path(['school', 'domain']))
  const history = useSelector(path(['history', 'history']))
  const { pathname } = useLocation()
  const { sendEvent } = useAnalytics()

  const priorPage = prop(dec(length(history)), history)

  if (equals(typeof window, 'undefined')) return

  useEffect(() => {
    if (
      all(equals(true))([not(isNil(domain)), not(equals(priorPage, pathname))])
    ) {
      sendEvent('YOU_App_Flow', {
        page_title: pathname,
        path: pathname,
        prior_page_title: priorPage,
        prior_path: priorPage
      })
    }
  }, [pathname, domain, priorPage])

  return
}

export default AppFlowHandler
